/*
 * SPDX-FileCopyrightText: 2025 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export const aggridIxThemeParams = {
  accentColor: `var(--theme-color-focus-bdr)`,
  backgroundColor: `var(--theme-color-2)`,
  headerColumnResizeHandleColor: `var(--theme-color-0)`,
  foregroundColor: `var(--theme-color-std-text)`,
  cellTextColor: `var(--theme-color-std-text)`,
  headerCellHoverBackgroundColor: `var(--theme-color-ghost--hover)`,
  advancedFilterBuilderJoinPillColor: `var(--theme-color-alarm-40)`,
  advancedFilterBuilderColumnPillColor: `var(--theme-color-success-40)`,
  advancedFilterBuilderOptionPillColor: `var(--theme-color-critical-40)`,
  advancedFilterBuilderValuePillColor: `var(--theme-color-info-40)`,
  selectedRowBackgroundColor: `var(--theme-color-ghost--selected)`,
  rowHoverColor: `var(--theme-color-ghost--hover)`,
  columnHoverColor: `var(--theme-color-ghost--hover)`,
  rangeSelectionBackgroundColor: `var(--theme-color-ghost--selected)`,
  rangeSelectionHighlightColor: `var(--theme-color-ghost--selected-hover)`,
  borderColor: `var(--theme-color-x-weak-bdr)`,
  headerBackgroundColor: `var(--theme-color-2)`,
  tooltipBackgroundColor: `var(--theme-color-2)`,
  oddRowBackgroundColor: `var(--theme-color-ghost-alt)`,
  sideBarBackgroundColor: `var(--theme-color-2)`,
  invalidColor: `var(--theme-color-alarm)`,
  checkboxUncheckedBorderColor: `var(--theme-color-contrast-bdr)`,
  checkboxCheckedBackgroundColor: `var(--theme-color-dynamic)`,
  checkboxCheckedColor: `var(--theme-color-dynamic)`,
  rangeSelectionBorderColor: `var(--theme-color-dynamic)`,
  sideButtonSelectedBackgroundColor: `var(--theme-color-ghost--selected)`,
  sideButtonSelectedUnderlineColor: `var(--theme-color-ghost--selected)`,
  valueChangeDeltaUpColor: `var(--theme-color-success)`,
  valueChangeDeltaDownColor: `var(--theme-color-alarm)`,
  inputBackgroundColor: `var(--theme-color-component-8)`,
  inputDisabledBackgroundColor: `var(--theme-color-ghost)`,
  inputDisabledBorder: `var(--theme-color-weak-bdr)`,
  inputInvalidBorderColor: `var(--theme-color-alarm)`,
  inputTextColor: `var(--theme-color-std-text)`,
  inputDisabledTextColor: `var(--theme-color-weak-text)`,
  buttonBackgroundColor: `var(--theme-color-ghost)`,
  buttonBorderColor: `var(--theme-color-component-4)`,
  buttonTextColor: `var(--theme-color-std-text)`,
  buttonDisabledBackgroundColor: `var(--theme-color-ghost)`,
  buttonDisabledBorderColor: `var(--theme-color-component-4)`,
  buttonDisabledTextColor: `var(--theme-color-weak-text)`,
  buttonHoverBackgroundColor: `var(--theme-color-ghost--hover)`,
  buttonHoverBorderColor: `var(--theme-color-component-4)`,
  buttonHoverTextColor: `var(--theme-color-std-text)`,
  buttonActiveBackgroundColor: `var(--theme-color-ghost--active)`,
  buttonActiveBorderColor: `var(--theme-color-component-4)`,
  buttonActiveTextColor: `var(--theme-color-std-text)`,
  toggleButtonSwitchBackgroundColor: `var(--theme-color-1)`,
  toggleButtonOffBackgroundColor: `var(--theme-color-component-4)`,
  toggleButtonOnBackgroundColor: `var(--theme-color-dynamic)`,
  iconColor: `var(--theme-color-std-text)`,
  menuBackgroundColor: `var(--theme-color-2)`,
  sideButtonsBackgroundColor: `var(--theme-color-0)`,
  footerRowBorderColor: `var(--theme-color-std-bdr)`,
  pinnedRowBackgroundColor: `var(--theme-color-ghost--selected)`,
  inputDisabledBorderColor: `var(--theme-color-weak-bdr)`,
  dialogBorderColor: `var(--theme-color-std-bdr)`,
  advancedFilterBuilderButtonBarBorderColor: `var(--theme-color-soft-bdr)`,
  columnDropCellBorderColor: `var(--theme-color-ghost)`,
  pinnedColumnBackgroundColor: `var(--theme-color-ghost--selected)`,
  headerRowBorderColor: `var(--theme-color-soft-bdr)`,
  headerColumnBorderColor: `var(--theme-color-0)`,
  cellEditingBorderColor: `var(--theme-color-dynamic)`,
  rowBorderColor: `var(--theme-color-weak-bdr)`,
  menuBorderColor: `var(--theme-color-std-bdr)`,
  sidePanelBorderColor: `var(--theme-color-x-weak-bdr)`,
  checkboxUncheckedBackgroundColor: `var(--theme-color-secondary)`,
  checkboxIndeterminateShapeColor: `var(--theme-color-primary--contrast)`,
  checkboxIndeterminateBackgroundColor: `var(--theme-color-dynamic)`,
  valueChangeValueHighlightBackgroundColor: `var(--theme-color-ghost--selected)`,
  columnDropCellDragHandleColor: `var(--theme-color-std-text)`,
  columnDropCellBackgroundColor: `var(--theme-color-component-1)`,
  columnDropCellTextColor: `var(--theme-color-std-text)`,
  rowLoadingSkeletonEffectColor: `var(--theme-color-2)`,
  statusBarLabelColor: `var(--theme-color-std-text)`,
  statusBarValueColor: `var(--theme-color-std-text)`,
  dragAndDropImageBackgroundColor: `var(--theme-color-2)`,
  inputIconColor: `var(--theme-color-std-text)`,
  dragHandleColor: `var(--theme-color-std-text)`,
  iconButtonHoverBackgroundColor: `var(--theme-color-ghost--hover)`,
  iconButtonHoverColor: `var(--theme-color-std-text)`,
  iconButtonColor: `var(--theme-color-std-text)`,
  iconButtonActiveBackgroundColor: `var(--theme-color-ghost--active)`,
  iconButtonBackgroundColor: `var(--theme-color-ghost)`,
  iconButtonActiveColor: `var(--theme-color-dynamic)`,
  iconButtonActiveIndicatorColor: `var(--theme-color-dynamic)`,
  subtleTextColor: `var(--theme-color-soft-text)`,
  advancedFilterBuilderButtonBarBorder: `var(--theme-color-soft-bdr)`,
  sideButtonsBarBackgroundColor: `var(--theme-color-2)`,
  sideButtonHoverBackgroundColor: `var(--theme-color-ghost--hover)`,
  checkboxCheckedShapeColor: `var(--theme-color-primary--contrast)`,
  OddRowBackgroundColor: `var(--theme-color-ghost-alt)`,
  tabBackgroundColor: `rgba(255, 255, 255, 0)`,
  tabBorderColor: `rgba(24, 29, 31, 0.15)`,
  tabHoverBackgroundColor: `rgba(255, 255, 255, 0)`,
  columnBorderColor: `var(--theme-borderColor)`,
  selectCellBorderColor: `var(--theme-borderColor)`,
  dragAndDropImageBorderColor: `var(--theme-color-std-bdr)`,
  tooltipBorderColor: `var(--theme-color-0)`,
  tabBarBackgroundColor: `var(--theme-color-2)`,
  tabSelectedUnderlineColor: `var(--theme-color-0)`,
  tabSelectedTextColor: `var(--theme-color-dynamic)`,
  'borderColor 2': `var(--theme-color-x-weak-bdr)`,
  chartBackgroundColor: `var(--theme-color-1)`,
  chartMenuLabelColor: `var(--theme-color-std-text)`,
  menuShadow: `var(--theme-shadow-4)`,
  headerColumnResizeHandleHeight: `100%`,
  headerColumnResizeHandleWidth: `1px`,
  icon: `true`,
  tooltipBorder: `false`,
  columnBorder: `false`,
  selectCellBorder: `true`,
  wrapperBorder: `false`,
  tabBarBorder: `false`,
  toolPanelSeparatorBorder: `false`,
  panelTitleBarBorder: `false`,
  sideButtonSelectedBorder: `false`,
  dragAndDropImageBorder: `false`,
  menuBorder: `false`,
  headerFontWeight: `700`,
  inputBorder: `var(--theme-border-width-default) solid var(--theme-input--border-color)`,
  inputFocusBorder: `var(--theme-focus-border-thickness) solid var(--theme-input--border-color--focus)`,
};
